"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProductsSection = require("./ProductsSection");
Object.keys(_ProductsSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductsSection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductsSection[key];
    }
  });
});